import { useEffect, useState } from "react";

import { Space } from "@prisma/client";
import { useSearchParams } from "@remix-run/react";
import "leaflet/dist/leaflet.css";

import { SpaceProps } from "~/types";

import FloorPlan from "./FloorPlan";
import { InnerMap } from "./Map.client";

export default function Map({
    className,
    spaces,
    selectSpace,
    selectedSpace,
}: {
    className?: string;
    spaces: Space[];
    selectSpace: (product: SpaceProps) => void;
    selectedSpace: SpaceProps | null;
}) {
    const [isClient, setIsClient] = useState(false);
    const [searchParams] = useSearchParams();

    const mausoleumId = searchParams.get("mausoleumId");

    useEffect(() => {
        setIsClient(true);
        return () => {
            setIsClient(false);
        };
    }, []);

    if (isClient) {
        const showMausoleumMap = !!mausoleumId;

        if (showMausoleumMap) {
            return (
                <FloorPlan name={mausoleumId} spaces={spaces} selectSpace={selectSpace} selectedSpace={selectedSpace} />
            );
        } else {
            return (
                <InnerMap
                    className={className}
                    spaces={spaces}
                    selectSpace={selectSpace}
                    selectedSpace={selectedSpace}
                />
            );
        }
    } else {
        return null;
    }
}
